export const createCallbackUrl = (id: number) =>
  location.protocol + '//' + location.host + location.pathname.replace(/\/$/, '') + '/' + id + '/' + location.search;
